import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image,
  url,
  type = 'website'
}) => {
  const baseUrl = process.env.REACT_APP_BACKEND_URL || 'https://invictus-green-power.preview.emergentagent.com';
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
  const defaultImage = `${baseUrl}/api/files/invictus-green/uploads/974218eb-5249-49d9-9fa5-bef235aac409.png`;
  const ogImage = image || defaultImage;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={fullUrl} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'RESCO Invictus Green Energy Solutions LLP',
          description: 'Leading provider of C&I Solar Power Plant solutions - Financing, Designing, Installing, Commissioning & O&M',
          url: baseUrl,
          logo: defaultImage,
          sameAs: []
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
